﻿/**
* DevExpress Analytics (query-builder\widgets\ace\_options.js)
* Version:  21.2.8
* Build date: Jun 7, 2022
* Copyright (c) 2012 - 2022 Developer Express Inc. ALL RIGHTS RESERVED
* License: https://www.devexpress.com/Support/EULAs/universal.xml
*/
"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./_ace-mode-sql");
function createDefaultSQLAceOptions(readOnly) {
    if (readOnly === void 0) { readOnly = false; }
    return {
        showLineNumbers: false,
        showPrintMargin: false,
        enableBasicAutocompletion: false,
        enableLiveAutocompletion: false,
        readOnly: readOnly,
        highlightSelectedWord: readOnly,
        showGutter: false,
        highlightActiveLine: false
    };
}
exports.createDefaultSQLAceOptions = createDefaultSQLAceOptions;
function createDefaultSQLAdditionalOptions(value) {
    return {
        onChange: function (session) {
            value(session.getValue());
        },
        onValueChange: function (editor) {
            editor.resize(true);
        },
        changeTimeout: 200,
        overrideEditorFocus: true,
        setUseWrapMode: true
    };
}
exports.createDefaultSQLAdditionalOptions = createDefaultSQLAdditionalOptions;
function createDefaultSQLLanguageHelper() {
    return {
        getLanguageMode: function () { return 'ace/mode/sql'; },
        createCompleters: function () { return []; }
    };
}
exports.createDefaultSQLLanguageHelper = createDefaultSQLLanguageHelper;
